import { createAsyncThunkFromFetch } from 'src/store/utils';
import { Package } from 'src/models';
import {
  activatePackageAPI,
  deactivatePackageAPI,
  getPackages,
} from './packages.api';

const prefix = 'packages';

export const fetchPackagesAction = createAsyncThunkFromFetch<
  Package[],
  { companyId: string }
>(`${prefix}/fetchPackages`, getPackages);

export const activatePackageAction = createAsyncThunkFromFetch<
  Package,
  { companyId: string; packageId: string }
>(`${prefix}/activatePackage`, activatePackageAPI);
export const deactivatePackageAction = createAsyncThunkFromFetch<
  Package,
  { companyId: string; packageId: string }
>(`${prefix}/deactivatePackage`, deactivatePackageAPI);
